import React, { memo, useCallback } from 'react'
import styled from 'styled-components'
import { Spacings, Text, Devices } from '@styles'

const TabHeader = styled.div`
	display: flex;
	border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};
	gap: ${Spacings.SPACING_3B};

	@media ${Devices.tablet} {
		gap: ${Spacings.SPACING_4B};
	}
`

const TabButton = styled.button`
	background: none;
	border: none;
	padding: ${Spacings.SPACING_6} 0;
	font-size: ${Text.SMALL};
	font-weight: ${Text.BOLD_700};
	color: ${({ active, theme }) => (active ? theme.colors.brand.primary : theme.colors.text.secondary)};
	border-bottom: 2px solid ${({ active, theme }) => (active ? theme.colors.brand.primary : 'transparent')};
	cursor: pointer;
	transition: all 0.2s;
	font-family: inherit;

	@media ${Devices.tablet} {
		padding: ${Spacings.SPACING_2B} 0;
		font-size: ${Text.BASE_SMALL};
	}

	&:hover {
		color: ${({ theme }) => theme.colors.brand.primary};
	}
`

// allowInReadOnly: render tabs as spans so a disabled <fieldset> (e.g. order history version view) can't disable them
const readOnlySafeProps = { as: 'span', role: 'tab', tabIndex: 0, 'data-version-allowed': true }

const SubTabs = memo(({ tabs, activeTab, onChange, allowInReadOnly = false, ...props }) => {
	const visibleTabs = tabs?.filter((tab) => !tab.hide) || []

	const handleTabClick = useCallback((e) => {
		const tabId = e.currentTarget.getAttribute('data-tab-id')
		if (onChange) {
			onChange(tabId)
		}
	}, [onChange])

	return (
		<TabHeader {...props}>
			{visibleTabs.map((tab) => (
				<TabButton
					key={tab.id}
					{...(allowInReadOnly ? readOnlySafeProps : {})}
					active={activeTab === tab.id}
					data-tab-id={tab.id}
					onClick={handleTabClick}
				>
					{tab.label}
				</TabButton>
			))}
		</TabHeader>
	)
})

export default SubTabs
